import { FolderPlus, Loader2, Plus, Upload } from "lucide-react";

import { IconButton } from "@/components/ui/icon-button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface ProjectDocumentAddMenuProps {
  isUploading: boolean;
  onCreateFolder: () => void;
  onUploadDocuments: () => void;
  onUploadRevision?: () => void;
}

export function ProjectDocumentAddMenu({
  isUploading,
  onCreateFolder,
  onUploadDocuments,
  onUploadRevision,
}: ProjectDocumentAddMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <IconButton
          label="Add to document library"
          icon={isUploading ? Loader2 : Plus}
          iconClassName={isUploading ? "animate-spin" : undefined}
          variant="default"
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onSelect={(event) => {
            event.preventDefault();
            onCreateFolder();
          }}
        >
          <FolderPlus className="size-4" />
          Create folder
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={(event) => {
            event.preventDefault();
            onUploadDocuments();
          }}
        >
          <Upload className="size-4" />
          Upload docs
        </DropdownMenuItem>
        {onUploadRevision ? (
          <DropdownMenuItem
            onSelect={(event) => {
              event.preventDefault();
              onUploadRevision();
            }}
          >
            <Upload className="size-4" />
            Upload revision
          </DropdownMenuItem>
        ) : null}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
